import { Link } from "react-router-dom";
import { animeList } from "@/mocks/anime";

export default function Ranking() {
  const ranked = [...animeList].sort((a, b) => b.rating - a.rating).slice(0, 5);
  const champion = ranked[0];
  const rest = ranked.slice(1);

  return (
    <section className="py-14 md:py-20">
      <div className="container-x">
        <div className="flex items-end justify-between">
          <div>
            <span className="flex items-center gap-1.5 text-sm font-medium text-accent-600">
              <i className="ri-medal-line"></i>
              本周精选榜单
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              今日下饭清单 TOP 5
            </h2>
            <p className="mt-2 max-w-lg text-sm text-foreground-600">
              小水每周亲自试看后整理的下饭番榜，短篇速刷不迷路，跟着榜单准没错。
            </p>
          </div>
          <Link
            to="/biaoqian"
            className="hidden items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 md:flex"
          >
            全部榜单 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <Link
            to={`/detail/${champion.id}`}
            className="group relative overflow-hidden rounded-3xl bg-foreground-950 lg:col-span-2"
          >
            <img
              src={champion.image}
              alt={`${champion.title} 本周下饭榜冠军`}
              className="h-80 w-full object-cover object-top opacity-80 transition-transform duration-500 group-hover:scale-105 lg:h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/20 to-transparent"></div>
            <div className="absolute left-6 top-6 flex items-center gap-2">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-secondary-500 font-heading text-xl font-black text-foreground-950">
                1
              </span>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-6">
              <p className="text-xs text-background-50/80">本周冠军 · {champion.season}</p>
              <h3 className="mt-1 font-heading text-xl font-bold text-background-50 md:text-2xl">
                {champion.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm text-background-50/80">{champion.synopsis}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-4 py-1.5 text-sm font-medium text-foreground-900">
                评分 {champion.rating} <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>

          <div className="lg:col-span-3">
            <ol className="space-y-3">
              {rest.map((anime, idx) => (
                <li key={anime.id}>
                  <Link
                    to={`/detail/${anime.id}`}
                    className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-all duration-200 hover:border-accent-300 hover:bg-accent-50"
                  >
                    <span className="w-8 text-center font-heading text-xl font-black text-foreground-300 group-hover:text-accent-600">
                      {idx + 2}
                    </span>
                    <img
                      src={anime.image}
                      alt={anime.title}
                      className="h-16 w-12 shrink-0 rounded-lg object-cover object-top"
                    />
                    <div className="min-w-0 flex-1">
                      <h3 className="truncate font-heading text-base font-bold text-foreground-950">
                        {anime.title}
                      </h3>
                      <p className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                        <span>{anime.genres.join(" · ")}</span>
                        <span className="hidden sm:inline">共{anime.episode}集</span>
                      </p>
                    </div>
                    <div className="hidden flex-col items-end sm:flex">
                      <span className="text-lg font-black text-accent-600">{anime.rating}</span>
                      <span className="text-xs text-foreground-400">评分</span>
                    </div>
                    <i className="ri-arrow-right-s-line text-lg text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-accent-600"></i>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}